module.exports = __webpack_public_path__ + "static/img/img3.0c85213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.png
// module id = m22b
// module chunks = 1